<template>
  <div class="status-box" v-if="usersStatusAPI">
    <template v-for="c in calendarSettings">
      <b-checkbox
        v-if="c.calendar_user === user.user_hash && !isSync"
        :key="c.pk"
        @input="$emit('changeShowEvent', c)"
        v-model="c.is_check"
        :indeterminate="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error'"
        :disabled="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error' || isConfirm"
        class="custom-calendar-checkbox"
        :style="getCheckboxStyle(c.calendar_user)">
      </b-checkbox>
    </template>
    <template v-if="isCalendarSettings(user.user_hash)">
      <b-checkbox
        @input="$emit('createCalendarSettings', {
          user: user,
          status: usersStatusAPI.status,
          other:other
        })"
        v-model="other"
        :indeterminate="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error'"
        :disabled="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error' || isConfirm"
        class="custom-calendar-checkbox"
        :style="getCheckboxStyle(user.user_hash)">
      </b-checkbox>
    </template>
    <template v-else-if="selfUser.userHash === user.user_hash">
      <b-checkbox
        v-model="self"
        @input="$emit('changeShowEventSelf', user.user_hash)"
        :indeterminate="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error'"
        :disabled="usersStatusAPI.status === 'none' || usersStatusAPI.status === 'error' || isConfirm"
        class="custom-calendar-checkbox"
        :style="getCheckboxStyle(user.user_hash)">
      </b-checkbox>
    </template>
    <Tooltip :message="usersStatusAPI.type">
      <template v-if="usersStatusAPI.status === 'ok'">
        <span style="color: green;" class="mdi mdi-check-circle-outline"></span>
      </template>
      <template v-else-if="usersStatusAPI.status === 'error'">
        <span style="color: red;" class="mdi mdi-comment-alert-outline"></span>
      </template>
      <template v-else>
        <span style="color: black;" class="mdi mdi-checkbox-blank-circle-outline"></span>
      </template>
    </Tooltip>
  </div>
  <div v-else>
    <span class="mdi mdi-loading mdi-spin"></span>
  </div>
</template>

<script>
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import { getUserCheckboxStyle } from '@/functions/balloonFunc'
import colorList from '@/assets/json/master/color.json'

export default {
  name: 'CalendarAPIStatus',
  components: {
    Tooltip
  },
  data () {
    return {
      self: this.default != undefined ? this.default : true,
      other: this.defaultOther != undefined ? this.defaultOther : false
    }
  },
  props: {
    user: {
      type: Object,
      require: true
    },
    calendarSettings: {
      type: Array,
      require: true
    },
    selfUser: {
      type: Object,
      require: true
    },
    default: {
      type: Boolean,
      require: false
    },
    usersStatusAPI: {
      type: Object,
      required: true,
    },
    defaultOther: {
      type: Boolean,
      require: false
    },
    isSync: {
      type: Boolean,
      require: false
    },
    isConfirm: {
      type: Boolean,
      require: false,
    },
  },
  methods: {
    isCalendarSettings (userHash) {
      if (this.isSync) return true
      if (this.selfUser.userHash === userHash) return false
      for (const cs of this.calendarSettings) {
        if (cs.calendar_user === userHash) {
          return false
        }
      }
      return true
    },
    getCheckboxStyle (userHash) {
      // Only pass selfUserHash when getting color for the logged-in user themselves
      const selfUserHash = userHash === this.selfUser.userHash ? this.selfUser.userHash : null
      return getUserCheckboxStyle(userHash, this.calendarSettings, colorList, selfUserHash)
    }
  }
}
</script>

<style lang='scss' scoped>
.status-box {
  display: flex;
}

.custom-calendar-checkbox {
  ::v-deep .b-checkbox.checkbox input[type=checkbox] + .check {
    border: 2px solid var(--checkbox-border-color, #8e44ad);
    transition: all 0.15s ease;
  }
  
  ::v-deep .b-checkbox.checkbox input[type=checkbox]:checked + .check {
    background: var(--checkbox-checked-background, #8e44ad) url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m13.854 3.646-7.5 7.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6 10.293l7.146-7.147a.5.5 0 0 1 .708.708z'/%3e%3c/svg%3e") no-repeat center center;
    border-color: var(--checkbox-checked-background, #8e44ad);
  }
  
  ::v-deep .b-checkbox.checkbox input[type=checkbox]:indeterminate + .check {
    background: var(--checkbox-checked-background, #8e44ad) url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='white'%3e%3cpath fill-rule='evenodd' d='M4 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H4.75A.75.75 0 014 10z' clip-rule='evenodd' /%3e%3c/svg%3e") no-repeat center center;
    border-color: var(--checkbox-checked-background, #8e44ad);
  }
  
  ::v-deep .b-checkbox.checkbox input[type=checkbox]:focus + .check {
    box-shadow: 0 0 0 0.125em var(--checkbox-border-color, rgba(142, 68, 173, 0.25));
  }
  
  ::v-deep .b-checkbox.checkbox input[type=checkbox]:hover + .check {
    border-color: var(--checkbox-border-color, #8e44ad);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Calendar/CalendarAPIStatus.vue